// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3K3iu","gfeWrapper":"CalendarEvent_gfeWrapper__3ldib"};